import React, { useRef, useState, useEffect } from "react";
import swamiji_image from "../../assets/images/swamiji.jpg";

export default function SchoolOfPostPharmacy() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div
        style={{
          height: "fit-content",
          flexDirection: windowWidth > 768 ? "row" : "column",
          display: "flex",
          justifyContent: "center",
          alignItems: windowWidth > 768 ? "" : "center",
          paddingTop: windowWidth > 768 ? "20vh" : "10vh",
          gap: "40px",
        }}
      >
        <nav
          class="d-flex flex-column shadow-sm py-3 navbar"
          style={{
            width: "250px",
            marginTop: "45px",
            backgroundColor: "#0054A4",
            padding: "10px",
            borderRadius: "10px",
            color: "white",
            height: "fit-content",
          }}
        >
          <p
            style={{
              backgroundColor: "rgb(230, 120, 23)",
              padding: "10px",
              borderRadius: "5px",
              marginBottom: "20px",
              width: "100%",
              textAlign: "center",
              color: "white",
              fontWeight: "bold",
            }}
          >
            PG Schools
          </p>
          <a
            class="nav-link text-white side-menu-link"
            href="/school-of-post-engineering"
          >
            &gt; School Of Engineering
          </a>
          <a
            class="nav-link text-white side-menu-link active"
            href="/school-of-management"
          >
            &gt; School Of Management
          </a>
          <a
            class="nav-link text-white side-menu-link"
            href="/school-of-life-sciences"
          >
            &gt; School Of Computer Applications
          </a>
          <a
            class="nav-link text-white side-menu-link"
            href="/school-of-life-sciences"
          >
            &gt; School Of Humanities
          </a>
          <a
            class="nav-link text-white side-menu-link"
            href="/school-of-post-pharmacy"
          >
            &gt; School Of Pharmacy
          </a>
        </nav>

        <section
          class="section-sm"
          style={{
            position: "relative",
            top: "30px",
          }}
        >
          <div class="container">
            <div class="row">
              <div class="col-12 mb-4">
                <a href="https://forms.gle/Rq2BE2mQ9fwrH8gTA" target="_blank">
                  <img
                    src="images/admission_apply_now.png"
                    class="img-fluid w-100"
                    style={{ height: "auto" }}
                    alt="Admission Apply Now"
                  />
                </a>
              </div>
            </div>
            <div class="row align-items-center mb-5">
              <div class="col-xl-6 order-1 col-sm-6 mb-4 mb-xl-0">
                <h2>School Of Pharmacy</h2>
              </div>

              <div class="col-xl-6 text-sm-right text-left order-sm-2 order-3 order-xl-3 col-sm-6 mb-4 mb-xl-0">
                <a
                  href="https://forms.gle/Rq2BE2mQ9fwrH8gTA"
                  target="_blank"
                  class="btn btn-primary"
                >
                  Apply now
                </a>
              </div>
              <div class="col-12 mt-4 order-4">
                <div class="border-bottom border-primary"></div>
              </div>
            </div>

            <div class="col-xl-6 order-1 col-sm-6 mb-4 mb-xl-0">
              <h3>M.Pharm</h3>
            </div>
            <div class="row">
              {/* Programme Information Boxes */}
              <div class="col-md-12 mb-4">
                <div class="col-md-12 mb-4">
                  <div class="card shadow">
                    <div class="card-body">
                      <h5 class="card-title">Pharmacuitics</h5>

                      <a href="/#" class="btn btn-primary btn-sm">
                        Learn More
                      </a>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 mb-4">
                  <div class="card shadow">
                    <div class="card-body">
                      <h5 class="card-title">
                      Pharmacology
                      </h5>

                      <a
                        href="/#"
                        class="btn btn-primary btn-sm"
                      >
                        Learn More
                      </a>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 mb-4">
                  <div class="card shadow">
                    <div class="card-body">
                      <h5 class="card-title">Regulatory Affairs</h5>

                      <a
                        href="/page-under-development"
                        class="btn btn-primary btn-sm"
                      >
                        Learn More
                      </a>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 mb-4">
                  <div class="card shadow">
                    <div class="card-body">
                      <h5 class="card-title">Pharmaceutical Analysis</h5>

                      <a
                        href="/#"
                        class="btn btn-primary btn-sm"
                      >
                        Learn More
                      </a>
                    </div>
                  </div>
                </div>

                {/* Add more programme information boxes here */}

                {/* <div class="col-12 mb-5">
                  <h3>Words From HOD's Desk</h3>
                  <p>
                    "Welcome to JSS University School of Engineering! As the
                    Head of Department, I am thrilled to invite you to embark on
                    a transformative journey of learning and innovation. Our
                    esteemed
                  </p>
                </div> */}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
